<app-navbar></app-navbar>

<section class="section-padding bg-light-theme">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-9">
        <div class="main-box padding-20">
          <h2 class="text-light-black fw-700 mb-3">Business Registration</h2>
          <p class="text-light-black mb-4">
            Please fill out the following fields to complete your onboarding.
          </p>

          <div *ngIf="isLoadingProfile" class="text-center py-5">
            <div class="spinner-border text-theme mb-3" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <p class="text-light-black mb-0">Loading sale representative information...</p>
          </div>

          <div
            *ngIf="!isLoadingProfile && (profileError || invalidLinkMessage || (!userProfile && hasSalePhone))"
            class="alert alert-danger"
          >
            <h5 class="fw-700 mb-2">Invalid Link</h5>
            <p class="mb-0">
              {{ profileError || invalidLinkMessage || 'Sale representative not found. Please contact your sale rep for more information.' }}
            </p>
          </div>

          <form
            *ngIf="!isLoadingProfile && userProfile && !profileError && !invalidLinkMessage"
            [formGroup]="customerForm"
            (ngSubmit)="onSubmit()"
            novalidate
            class="customer-form"
          >
            <div class="row">
              <div class="col-12">
                <h5 class="text-light-black fw-700">General Information</h5>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label class="text-light-black fw-700" for="businessName">
                    Business Name
                  </label>
                  <input
                    id="businessName"
                    class="form-control form-control-submit"
                    placeholder="e.g. Beauty Studio LLC"
                    formControlName="businessName"
                  />
                  <small *ngIf="hasControlError('businessName')" class="text-danger">
                    Business name is required.
                  </small>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label class="text-light-black fw-700" for="businessPhone">
                    Business Phone
                  </label>
                  <input
                    id="businessPhone"
                    class="form-control form-control-submit"
                    placeholder="(123) 456-7890"
                    formControlName="businessPhone"
                    (input)="formatPhoneNumber($event)"
                  />
                  <small *ngIf="hasControlError('businessPhone')" class="text-danger">
                    Enter a valid phone number.
                  </small>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label class="text-light-black fw-700" for="businessEmail">
                    Business Email
                  </label>
                  <input
                    id="businessEmail"
                    type="email"
                    class="form-control form-control-submit"
                    placeholder="example@email.com"
                    formControlName="businessEmail"
                  />
                  <small *ngIf="hasControlError('businessEmail')" class="text-danger">
                    Enter a valid email address.
                  </small>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label class="text-light-black fw-700" for="businessType">
                    Business Type
                  </label>
                  <select
                    id="businessType"
                    class="form-control form-control-submit"
                    formControlName="businessType"
                  >
                    <option value="" disabled>Select business type</option>
                    <option *ngFor="let type of businessTypesList" [value]="type">
                      {{ capitalizeWords(type) }}
                    </option>
                  </select>
                  <small *ngIf="hasControlError('businessType')" class="text-danger">
                    Please choose a business type.
                  </small>
                </div>
              </div>
            </div>

            <div class="u-line mb-4"></div>

            <div class="row">
              <div class="col-12">
                <h5 class="text-light-black fw-700">Location</h5>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label class="text-light-black fw-700" for="businessAddress">
                    Address
                  </label>
                  <input
                    id="businessAddress"
                    class="form-control form-control-submit"
                    placeholder="1234 Main St"
                    formControlName="businessAddress"
                  />
                  <small *ngIf="hasControlError('businessAddress')" class="text-danger">
                    Address is required.
                  </small>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label class="text-light-black fw-700" for="businessAddress2">
                    Address 2
                  </label>
                  <input
                    id="businessAddress2"
                    class="form-control form-control-submit"
                    placeholder="Apartment, suite, etc. (optional)"
                    formControlName="businessAddress2"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label class="text-light-black fw-700" for="businessCity">
                    City
                  </label>
                  <input
                    id="businessCity"
                    class="form-control form-control-submit"
                    placeholder="San Francisco"
                    formControlName="businessCity"
                  />
                  <small *ngIf="hasControlError('businessCity')" class="text-danger">
                    City is required.
                  </small>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <label class="text-light-black fw-700" for="businessState">
                    State
                  </label>
                  <select
                    id="businessState"
                    class="form-control form-control-submit"
                    formControlName="businessState"
                  >
                    <option value="" disabled>Select state</option>
                    <option *ngFor="let state of statesList" [value]="state">
                      {{ state }}
                    </option>
                  </select>
                  <small *ngIf="hasControlError('businessState')" class="text-danger">
                    State is required.
                  </small>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <label class="text-light-black fw-700" for="businessZipCode">
                    Zip Code
                  </label>
                  <input
                    id="businessZipCode"
                    class="form-control form-control-submit"
                    placeholder="10001"
                    formControlName="businessZipCode"
                  />
                  <small *ngIf="hasControlError('businessZipCode')" class="text-danger">
                    Zip code is required.
                  </small>
                </div>
              </div>
            </div>

            <div class="u-line mb-4"></div>

            <div class="row">
              <div class="col-12">
                <h5 class="text-light-black fw-700">Services Offered</h5>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-md-6" *ngFor="let service of servicesOfferedList">
                    <div class="custom-checkbox d-flex align-items-center mb-2">
                      <input
                        type="checkbox"
                        [id]="service"
                        [checked]="isServiceSelected(service)"
                        (change)="toggleService(service, $any($event.target).checked)"
                      />
                      <label class="text-light-black mb-0 ml-2" [for]="service">
                        {{ capitalizeWords(service) }}
                      </label>
                    </div>
                  </div>
                </div>
                <small *ngIf="hasControlError('servicesOffered')" class="text-danger d-block">
                  Select at least one service.
                </small>
              </div>
            </div>

            <div class="text-right mt-4">
              <button
                type="submit"
                class="btn-first green-btn text-custom-white px-4"
                [disabled]="isSubmitting"
              >
                {{ isSubmitting ? 'Submitting...' : 'Submit' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>

<app-footer2></app-footer2>